import React from "react";

// Irregular torn-paper divider. `topColor` = section above, `bottomColor` = section below.
export default function TornDivider({ topColor = "#FFC20E", bottomColor = "#0C0C0C", flip = false }) {
  const path =
    "M0,32 L60,20 L120,40 L200,14 L280,44 L360,22 L440,48 L520,18 L600,46 L680,24 L760,50 L840,20 L920,44 L1000,16 L1080,46 L1160,22 L1240,48 L1320,20 L1400,42 L1440,28 L1440,0 L0,0 Z";
  return (
    <div className="relative w-full leading-[0]" style={{ backgroundColor: bottomColor }} aria-hidden="true">
      <svg
        viewBox="0 0 1440 64"
        preserveAspectRatio="none"
        className="block w-full h-[36px] sm:h-[56px]"
        style={{ transform: flip ? "scaleY(-1)" : "none" }}
      >
        <path d={path} fill={topColor} />
      </svg>
    </div>
  );
}
